import { ITripsTableData } from 'pages/Trips/TripsTable/TripsTable.model';

export enum TripsActions {
  SetSeleceted = '[Trips] Set Selected',
  SetOnQueueRemove = '[Trips] Set On Queue Remove',
  SetOnQueueAssign = '[Trips] Set On Queue Assign',
  SetUserAssign = '[Trips] Set User Assign',
  MarkAutoAssigned = '[Trips] Mark Auto Assigned',
  ClearAutoAssigned = '[Trips] Clear Auto Assigned',
}

export type SetSeleceted = {
  type: TripsActions.SetSeleceted;
  payload: { trips: ITripsTableData[] };
};

export type SetOnQueueRemove = {
  type: TripsActions.SetOnQueueRemove;
  payload: { callback: ((jobIds: number[]) => void) | null };
};

export type SetOnQueueAssign = {
  type: TripsActions.SetOnQueueAssign;
  payload: { callback: ((jobIds: number[]) => void) | null };
};

export type MarkAutoAssigned = {
  type: TripsActions.MarkAutoAssigned;
  payload: { tripIds: number[] };
};

export type ClearAutoAssigned = {
  type: TripsActions.ClearAutoAssigned;
  payload: { tripId: number };
};

// Action creators

export const setSelected = (trips: ITripsTableData[]): SetSeleceted => {
  return {
    type: TripsActions.SetSeleceted,
    payload: { trips },
  };
};

export const SetOnQueueRemove = (callback: ((jobIds: number[]) => void) | null): SetOnQueueRemove => {
  return {
    type: TripsActions.SetOnQueueRemove,
    payload: { callback },
  };
};

export const SetOnQueueAssign = (callback: ((jobIds: number[]) => void) | null): SetOnQueueAssign => {
  return {
    type: TripsActions.SetOnQueueAssign,
    payload: { callback },
  };
};

export const markAutoAssigned = (tripIds: number[]): MarkAutoAssigned => ({
  type: TripsActions.MarkAutoAssigned,
  payload: { tripIds },
});

export const clearAutoAssigned = (tripId: number): ClearAutoAssigned => ({
  type: TripsActions.ClearAutoAssigned,
  payload: { tripId },
});

export type TripsTypes = SetSeleceted | SetOnQueueRemove | SetOnQueueAssign | MarkAutoAssigned | ClearAutoAssigned;
